import { render, staticRenderFns } from "./TranslationsPage.vue?vue&type=template&id=5d5c358a&scoped=true"
import script from "./TranslationsPage.vue?vue&type=script&lang=js"
export * from "./TranslationsPage.vue?vue&type=script&lang=js"
import style0 from "./TranslationsPage.vue?vue&type=style&index=0&id=5d5c358a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c358a",
  null
  
)

export default component.exports